import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { AiOutlineRight, AiOutlineArrowLeft } from "react-icons/ai";
import { Badge, Modal, Table } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../component/loader';
import ProductDetailsThumbImage from '../../component/productDetailsThumbImg';
import axios from 'axios';
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import ReactHtmlParser from 'react-html-parser';
import { FaStore, FaTruck, FaFileAlt, FaInfoCircle, FaShieldAlt, FaExternalLinkAlt, FaBoxes, FaTags } from "react-icons/fa";

function ProductSingle() {
  const [loader, setLoader] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [productDetails, setProductDetails] = useState(null);

  const fetchProductDitails = async () => {
    setLoader(true);
    const data = {
      id: location.state?.item,
    };
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/product/details`, data);
      if (response.data.success) {
        setLoader(false);
        setProductDetails(response.data.data);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleDeleteProduct = async () => {
    setLoader(true);
    setDeleteModal(false);
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/product/delete`, { id: location.state?.item });
      if (response.data.success) {
        toast.success(response.data.message || 'Product deleted successfully', { hideProgressBar: true });
        setTimeout(() => {
          navigate('/product');
        }, 800);
      } else {
        toast.error(response.data.message || 'Failed to delete product', { hideProgressBar: true });
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || 'Failed to delete product', { hideProgressBar: true });
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProductDitails();
  }, []);

  const renderContent = (val) => {
    if (!val || val === '') {
      return <span className="text-muted fst-italic">Not Provided</span>;
    }
    if (typeof val === 'string' && (val.includes('<p>') || val.includes('<div>') || val.includes('<ul>') || val.includes('<br>'))) {
      return ReactHtmlParser(val);
    }
    return <div style={{ whiteSpace: 'pre-line' }}>{val}</div>;
  };

  const renderStatusBadge = (status) => {
    const s = Number(status);
    if (s === 1) {
      return <Badge bg="success">Active</Badge>;
    } else if (s === 2) {
      return <Badge bg="warning" text="dark">Inactive</Badge>;
    } else if (s === 3) {
      return <Badge bg="info">Pending Approval</Badge>;
    } else if (s === 4) {
      return <Badge bg="danger">Rejected</Badge>;
    }
    return <Badge bg="secondary">Unknown</Badge>;
  };

  return (
    <div className="main-content">
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="section">
            {/* Top Bar with Navigation & Actions */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <button 
                type="button" 
                className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                onClick={() => navigate('/product')}
              >
                <AiOutlineArrowLeft /> Back to Products
              </button>
              <button 
                type="button" 
                className="btn btn-sm btn-danger text-white" 
                onClick={() => setDeleteModal(true)}
              >
                Delete Product
              </button>
            </div>

            {/* Product Overview Card */}
            <div className="card mb-3 p-3">
              <div className="row">
                <div className="col-lg-8 col-md-7">
                  <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <h3 className="h5 fw-bold mb-0 text-success">{productDetails?.name}</h3>
                    {renderStatusBadge(productDetails?.status)}
                    {Number(productDetails?.is_featured) === 1 && (
                      <Badge bg="info">Featured</Badge>
                    )}
                  </div>

                  {/* Categories Hierarchy */}
                  <div className="d-flex align-items-center text-muted small mb-2 flex-wrap">
                    <span className="fw-semibold">{productDetails?.category || 'Category'}</span>
                    &nbsp; <AiOutlineRight size={12} /> &nbsp;
                    <span className="fw-semibold">{productDetails?.sub_category || 'Sub Category'}</span>
                    &nbsp; <AiOutlineRight size={12} /> &nbsp;
                    <span className="fw-semibold">{productDetails?.third_category || 'Child Category'}</span>
                  </div>

                  {/* Brand & Basic Meta */}
                  <div className="row g-2 mt-2">
                    <div className="col-sm-6">
                      <div className="p-2 border rounded bg-light">
                        <small className="text-muted d-block">Brand</small>
                        <span className="fw-bold">
                          {productDetails?.brand ? (
                            <Badge bg="primary">{productDetails.brand}</Badge>
                          ) : (
                            <Badge bg="secondary">Non-Brand</Badge>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-2 border rounded bg-light">
                        <small className="text-muted d-block">Applicable GST</small>
                        <span className="fw-bold text-dark">
                          {productDetails?.gst != null && productDetails?.gst !== '' ? `${productDetails.gst}%` : 'Not Specified'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Dimensions & Weight */}
                  <div className="p-2 border rounded bg-light mt-2">
                    <small className="text-muted d-block fw-semibold mb-1">Package Dimensions & Weight</small>
                    <div className="row text-center g-2">
                      <div className="col-3">
                        <div className="bg-white p-1 rounded border">
                          <small className="text-muted d-block" style={{ fontSize: '11px' }}>Weight</small>
                          <span className="fw-bold" style={{ fontSize: '13px' }}>{productDetails?.weight ?? 0} gm</span>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="bg-white p-1 rounded border">
                          <small className="text-muted d-block" style={{ fontSize: '11px' }}>Length</small>
                          <span className="fw-bold" style={{ fontSize: '13px' }}>{productDetails?.length ?? 0} cm</span>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="bg-white p-1 rounded border">
                          <small className="text-muted d-block" style={{ fontSize: '11px' }}>Width</small>
                          <span className="fw-bold" style={{ fontSize: '13px' }}>{productDetails?.width ?? 0} cm</span>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="bg-white p-1 rounded border">
                          <small className="text-muted d-block" style={{ fontSize: '11px' }}>Height</small>
                          <span className="fw-bold" style={{ fontSize: '13px' }}>{productDetails?.height ?? 0} cm</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Short Description */}
                  <div className="mt-3">
                    <label className="fw-bold mb-1">Short Description</label>
                    <div className="p-2 border rounded bg-white text-secondary" style={{ fontSize: '14px' }}>
                      {renderContent(productDetails?.short_description)}
                    </div>
                  </div>
                </div>

                {/* Right Side - Media Gallery */}
                <div className="col-lg-4 col-md-5 mt-3 mt-md-0">
                  <div className="border rounded p-2 bg-light text-center h-100 d-flex flex-column justify-content-between">
                    <div>
                      <label className="fw-bold d-block text-start mb-2">Product Images</label>
                      <div className="text-center mb-2" style={{ background: '#fff', borderRadius: '8px', padding: '10px' }}>
                        {productDetails?.main_image ? (
                          <img
                            src={productDetails.main_image}
                            alt="Main Product"
                            style={{ maxHeight: '220px', maxWidth: '100%', objectFit: 'contain' }}
                          />
                        ) : (
                          <div className="text-muted py-5">No Main Image</div>
                        )}
                      </div>

                      {/* Additional Images Thumbnail Gallery */}
                      {productDetails?.images && productDetails.images.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                          {productDetails.images.map((item, index) => (
                            <ProductDetailsThumbImage key={index} image={item.image} />
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Size Chart Image */}
                    {productDetails?.size_chart_image && (
                      <div className="mt-3 pt-2 border-top text-start">
                        <small className="fw-bold text-muted d-block mb-1">Size Chart</small>
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={productDetails.size_chart_image}
                            alt="Size Chart"
                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }}
                          />
                          <a
                            href={productDetails.size_chart_image}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                            style={{ fontSize: '12px' }}
                          >
                            <FaExternalLinkAlt size={11} /> View Full Size Chart
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Seller & Dispatch Address Details */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="card h-100 p-3">
                  <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                    <FaStore className="text-primary" /> Seller Information
                  </h6>
                  <div className="mt-2">
                    <div className="mb-2">
                      <span className="text-muted small d-block">Seller Name</span>
                      <strong className="text-dark">{productDetails?.seller?.name || productDetails?.seller_name || 'N/A'}</strong>
                    </div>
                    <div className="mb-2">
                      <span className="text-muted small d-block">Email Address</span>
                      <span className="text-dark">{productDetails?.seller?.email || 'N/A'}</span>
                    </div>
                    <div>
                      <span className="text-muted small d-block">Contact Phone</span>
                      <span className="text-dark">{productDetails?.seller?.mobile || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="card h-100 p-3">
                  <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                    <FaTruck className="text-success" /> Pickup & Shipping Location
                  </h6>
                  <div className="mt-2">
                    <div className="mb-2">
                      <span className="text-muted small d-block">Pickup Location / Code</span>
                      <strong className="text-dark">{productDetails?.pickup_location || 'Not Configured'}</strong>
                    </div>
                    <div className="mb-2">
                      <span className="text-muted small d-block">Facility / Contact Name</span>
                      <span className="text-dark">{productDetails?.pickup_address_name || 'N/A'}</span>
                    </div>
                    <div>
                      <span className="text-muted small d-block">Complete Address</span>
                      <span className="text-dark">{productDetails?.pickup_address_details || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing, Inventory & Sizes */}
            <div className="card mb-3 p-3">
              <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                <FaBoxes className="text-warning" /> Pricing, Stock & Variant Details
              </h6>
              <div className="table-responsive mt-2">
                {productDetails?.stock_details && productDetails.stock_details.length > 0 ? (
                  <Table bordered hover className="align-middle text-center mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>SKU</th>
                        <th>Size / Variant</th>
                        <th>MRP (₹)</th>
                        <th>Selling Price (₹)</th>
                        <th>Stock Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails.stock_details.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <code className="text-dark fw-bold">{item.sku || 'N/A'}</code>
                          </td>
                          <td>
                            <Badge bg="secondary">{item.size || 'Standard'}</Badge>
                          </td>
                          <td className="text-dark">₹ {item.mrp}</td>
                          <td className="fw-bold text-success">₹ {item.price}</td>
                          <td>
                            <span className={item.stock > 0 ? 'badge bg-success' : 'badge bg-danger'}>
                              {item.stock} in stock
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div className="row text-center g-3 p-2">
                    <div className="col-md-4">
                      <div className="p-2 border rounded bg-light">
                        <small className="text-muted d-block">MRP</small>
                        <h6 className="mb-0 text-dark">₹ {productDetails?.mrp ?? 0}</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="p-2 border rounded bg-light">
                        <small className="text-muted d-block">Selling Price</small>
                        <h6 className="mb-0 text-success fw-bold">₹ {productDetails?.price ?? 0}</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="p-2 border rounded bg-light">
                        <small className="text-muted d-block">Available Stock</small>
                        <h6 className="mb-0 text-dark fw-bold">{productDetails?.stock ?? 0} units</h6>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Product Filters / Attributes */}
            {productDetails?.filters && productDetails.filters.length > 0 && (
              <div className="card mb-3 p-3">
                <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                  <FaTags className="text-info" /> Product Attributes & Filters
                </h6>
                <div className="table-responsive mt-2">
                  <Table bordered size="sm" className="mb-0 align-middle">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '40%' }}>Attribute Name</th>
                        <th style={{ width: '60%' }}>Selected Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails.filters.map((flt, idx) => (
                        <tr key={idx}>
                          <td className="fw-semibold text-secondary">{flt.name || 'Attribute'}</td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              {flt.hex_code && (
                                <span
                                  style={{
                                    display: 'inline-block',
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '50%',
                                    backgroundColor: flt.hex_code,
                                    border: '1px solid #ccc',
                                  }}
                                />
                              )}
                              <span>{flt.value || 'N/A'}</span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}

            {/* Specifications & Key Features */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="card h-100 p-3">
                  <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                    <FaFileAlt className="text-primary" /> Key Features / Product Features
                  </h6>
                  <div className="p-2 rounded bg-light mt-2" style={{ fontSize: '14px', minHeight: '120px' }}>
                    {renderContent(productDetails?.key_features)}
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="card h-100 p-3">
                  <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                    <FaInfoCircle className="text-info" /> Product Specifications
                  </h6>
                  <div className="p-2 rounded bg-light mt-2" style={{ fontSize: '14px', minHeight: '120px' }}>
                    {renderContent(productDetails?.specifications)}
                  </div>
                </div>
              </div>
            </div>

            {/* Compliance, Origin & Metrology Information */}
            <div className="card mb-3 p-3">
              <h6 className="fw-bold text-dark d-flex align-items-center gap-2 border-bottom pb-2">
                <FaShieldAlt className="text-secondary" /> Regulatory & Compliance Information
              </h6>
              <div className="row g-3 mt-1">
                <div className="col-md-6">
                  <div className="p-2 border rounded bg-light h-100">
                    <small className="text-muted d-block fw-semibold mb-1">Country of Origin</small>
                    <span className="fw-bold text-dark">{productDetails?.country_of_origin || 'Not Specified'}</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-2 border rounded bg-light h-100">
                    <small className="text-muted d-block fw-semibold mb-1">Manufacturer Information (Name & Address)</small>
                    <div style={{ fontSize: '13px' }}>{renderContent(productDetails?.manufacturer_info)}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-2 border rounded bg-light h-100">
                    <small className="text-muted d-block fw-semibold mb-1">Packer Information (Name & Address)</small>
                    <div style={{ fontSize: '13px' }}>{renderContent(productDetails?.packer_info)}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-2 border rounded bg-light h-100">
                    <small className="text-muted d-block fw-semibold mb-1">Importer Information (Name & Address)</small>
                    <div style={{ fontSize: '13px' }}>{renderContent(productDetails?.importer_info)}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Long Description */}
            <div className="card mb-3 p-3">
              <h6 className="fw-bold text-dark border-bottom pb-2">Product Long Description</h6>
              <div className="p-2 mt-2" style={{ fontSize: '14px' }}>
                {renderContent(productDetails?.description)}
              </div>
            </div>

            {/* Return Policy & Cancellation Policy */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="card h-100 p-3">
                  <h6 className="fw-bold text-dark border-bottom pb-2">Return Policy</h6>
                  <div className="mt-2">
                    {productDetails?.return_day && productDetails.return_day !== 0 ? (
                      <div className="mb-2">
                        <Badge bg="success" className="me-2">{productDetails.return_day} Days Return Window</Badge>
                      </div>
                    ) : (
                      <div className="mb-2">
                        <Badge bg="secondary">Non-Returnable Product</Badge>
                      </div>
                    )}
                    <div className="text-muted small mt-2">
                      {renderContent(productDetails?.return_policy_details?.return_policy || productDetails?.return_policy)}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="card h-100 p-3">
                  <h6 className="fw-bold text-dark border-bottom pb-2">Cancellation Policy</h6>
                  <div className="mt-2">
                    <div className="text-muted small">
                      {renderContent(productDetails?.cancel_policy_details?.policy || productDetails?.cancel_policy || 'Standard cancellation policy applies.')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Delete Product Modal */}
          <Modal size="sm" show={deleteModal} onHide={() => setDeleteModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title className="h6 fw-bolder">Delete Product</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-2">
              <p className="mb-1 text-muted" style={{ fontSize: '13px' }}>
                Are you sure you want to delete this product?
              </p>
              <strong className="text-dark d-block mb-2" style={{ fontSize: '14px' }}>
                {productDetails?.name}
              </strong>
              <small className="text-danger">This action cannot be undone.</small>
            </Modal.Body>
            <Modal.Footer className="p-2">
              <button onClick={() => setDeleteModal(false)} className="btn btn-light btn-sm">
                Cancel
              </button>
              <button onClick={() => handleDeleteProduct()} className="btn btn-danger btn-sm">
                Yes, Delete
              </button>
            </Modal.Footer>
          </Modal>

          <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme={'colored'} />
        </>
      )}
    </div>
  );
}

export default ProductSingle;
